import {
	type PartnerAvailabilityBulkUpdateDto,
	putPartnersCalendarAvailabilityBulk,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useMutation } from "@tanstack/react-query";

export function useBulkUpsertPartnerAvailabilityMutation() {
	return useMutation({
		mutationFn: processResponse((data: PartnerAvailabilityBulkUpdateDto) =>
			putPartnersCalendarAvailabilityBulk(data),
		),
	});
}
